import React from 'react';

import { useService } from '@xstate/react';

import { productBuilderMachine } from '../../../context/ProductBuilder/machine';
import { isCurrentState } from '../../../helpers/isCurrentState';
import { getTiltControlOptions } from '../../../helpers/tiltControl';
import { throwError } from '../../../helpers/throwError';
import { ProductBuilderMachineEvent } from '../../../types';
import { Heading } from '../../Common/Heading';
import {
  Selector,
  SelectorItem,
  SelectorImageItem,
} from '../../Common/Selector';
import { SectionContent } from './SectionContent';
import { getProductStateConfig } from '../../../helpers/getProductStateConfig';
import { getBaseProductType } from '../../../helpers/getBaseProductType';
import { Caption } from '../../Common/Caption';

type OnClick = (
  tiltControl: string,
  send: (event: ProductBuilderMachineEvent) => void,
) => () => void;

const onClick: OnClick = (tiltControl, send) => () => {
  send({
    type: 'UPDATE_CUSTOM',
    custom: {
      tiltControl,
    },
  });
};

export const TiltControl = () => {
  const [state, send] = useService(productBuilderMachine);
  const {
    custom: { tiltControl },
  } = state.context;
  const tiltControlOptions = getTiltControlOptions(state.context);
  const productType = getBaseProductType(state.context);

  if (isCurrentState('tiltControl', state) && tiltControlOptions.length === 0) {
    throwError(state);
  }

  return (
    <SectionContent>
      <Heading>Tilt Control</Heading>
      <Selector isSlider={true}>
        {tiltControlOptions.map(option => {
          const { showIcon, Icon, description } = getProductStateConfig(
            productType,
            'tiltControl',
            option,
          );
          return (
            <SelectorImageItem
              isSelected={option === tiltControl}
              onClick={onClick(option, send)}
              showIcon={showIcon}
              Icon={Icon}
              title={option}
              key={option}
              description={description}
            />
          );
        })}
      </Selector>
    </SectionContent>
  );
};
